import { WorkflowTask } from "./workflow-task";

export class DeployPhase {
  rank!: number;
  name: string;
  workflowTasks: WorkflowTask[];
  status = 'unchanged';
  childStatus = 'unchanged';

  public constructor(name: string, rank: number, workflowTasks: WorkflowTask[]) {
    this.name = name;
    this.rank = rank;
    this.workflowTasks = workflowTasks;
  }
}